import { render } from "./Create-new-rush.vue?vue&type=template&id=317a7625&scoped=true"
import script from "./Create-new-rush.vue?vue&type=script&lang=js"
export * from "./Create-new-rush.vue?vue&type=script&lang=js"

import "./Create-new-rush.vue?vue&type=style&index=0&id=317a7625&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317a7625"]])

export default __exports__